import React, {useContext, useEffect, useRef} from "react";
import {useQuery} from "@tanstack/react-query";
import {Card} from "../../../../../../components/card/card.jsx";
import {AgentContext} from "../../context/agent-context.jsx";
import AgentInfoService from "../../../../../../services/reports/agent-info-service.js";
import PrintTemplate from "../../../../../../components/reports/print-reports/print-template.jsx";
import ReportUtils from "../../../../../../utils/report-utils.js";
import PrintOptionsModal from "../../../../../../components/print-options-modal/print-options-modal.jsx";
import ReportContent from "../../../../../reports/agent-info/components/report/report-content.jsx";

const userModules = [
    { key: "documents", permission: "sentry.user.documents"},
    { key: "trainings", permission: "sentry.user.trainings"},
    { key: "conductHistory", permission: "sentry.user.conduct_history"},
    { key: "privateWeapons", permission: "sentry.user.private_weapons"},
    { key: "dayOff", permission: "sentry.user.absences"},
    { key: "clothes", permission: "sentry.user.clothes"},
    { key: "dependents", permission: "sentry.user.dependents"},
    { key: "skillsRestrictions", permission: "sentry.user.skills_restrictions"},
];

const Resume = () => {
    const { id, userInfo, setPrintResume, headerSelected = -1, setIsLoading, printFields, printModal, setPrintModal, printOptions, setPrintOptions } = useContext(AgentContext);
    const printComponentRef = useRef(null);

    const { data: reportData } = useQuery({
        queryKey: ["report-user", id],
        queryFn: () => AgentInfoService.getUser(id),
        enabled: !!id,
    });

    const permissions = userInfo?.userLoggedPermissions ?? [];

    const visibleModules = Object.fromEntries(
        userModules.map(module => [
            module.key,
            permissions.includes(module.permission),
        ])
    );

    const allowedPrintFields = printFields.filter((item) => {
        if (!item.permission) return true;
        return permissions.includes(item.permission);
    });

    const printItems = [
        {
            title: "",
            options: allowedPrintFields,
        }
    ];

    useEffect(() => {
        setPrintResume(() => () => {
            try {
                printComponentRef.current?.print();
            } catch (error) {
                setIsLoading(false);
                ReportUtils.alertErrorMessage("Erro ao imprimir resumo.");
                console.error(error);
            }
        });

        return () => setPrintResume(null);
    }, [setIsLoading, setPrintResume]);

    return (
        <>
            <section className="h-[calc(100vh-131px)] overflow-y-auto">
                <Card className="w-full max-w-[1030px] mx-auto">
                    <Card.Body className={'!p-6'}>
                        <PrintTemplate entity={headerSelected} title={'Agente'} ref={printComponentRef} setIsPrinting={setIsLoading}>
                            <ReportContent
                                data={reportData}
                                visibleModules={visibleModules}
                                printOptions={printOptions}
                            />
                        </PrintTemplate>
                    </Card.Body>
                </Card>
            </section>

            <PrintOptionsModal
                open={printModal}
                setOpen={setPrintModal}
                printRef={printComponentRef}
                options={printOptions}
                setOptions={setPrintOptions}
                items={printItems}
            />
        </>
    );
};

export default Resume;
